import React, { useEffect, useState } from 'react';
import './styles.css';
import { callApis, callGetApis, callFetchApis } from '../../helper/fetching';
import { FormSection } from '../../components/FormSection'
import { flattenMongoSchema } from '../../helper/flattenMongoApplicationData'
import axios from "axios";
import * as moment from "moment";
import Navbar from '../../components/Navbar';
import InfoIcon from '../../assets/infoIcon.webp';
import { useNavigate } from 'react-router-dom';
import { attachmentsList, itrAttachmentsList, signedLetterAttachmentsList } from './attachmentsList';
import { resolveAdminStatusPage } from './adminStatusPage';
import { APPLICATION_EDIT_DEADLINE_DISPLAY } from '../../constants/dates';

const UserDetailsComponent = () => {
    const _url = "https://api-univ.sitare.org/"
    const navigate = useNavigate()
    const [applicantPhotoUploaded, setApplicantPhotoUploaded] = useState(false);
    const [isAccepted, setIsAccepted] = useState(false);
    const [isSignedLetterRequired, setIsSignedLetterRequired] = useState(false);
    const [fields, setFields] = useState({

        // Personal Details
        firstName: "",
        middleName: "",
        lastName: "",
        dob: "",
        gender: "Female",
        category: "",

        // Contact Details
        email: "",
        mobile: localStorage.getItem('currentuser') || "",
        whatsappMobile: "",
        currentAddress: "",
        permanentAddress: "",

        // Family Details
        familyIncome: "",

        // --Father
        fatherName: "",
        fatherOccupation: "",
        fatherMobile: "",
        fatherAadhar: "",
        fatherIncome: "",

        // --Mother
        motherName: "",
        motherOccupation: "",
        motherMobile: "",
        motherAadhar: "",
        motherIncome: "",

        // --Siblings
        numSiblings: 0,
        siblings: [
            {
                name: "",
                age: "",
                siblingType: "",
                occupation: "",
                annualIncome: "",
            }
        ],

        // Coaching Info
        coachingBy: "Others",
        coachingByOthers: "",

        // Class 10 Details
        board10: "",
        math10: "",
        science10: "",
        english10: "",
        school10: "",
        state10: "",
        schoolType10: "",
        overall10: "",

        // Class 12 Details
        board12: "",
        math12: "",
        physics12: "",
        english12: "",
        school12: "",
        state12: "",
        schoolType12: "",
        overall12: "",

        // JEE Mains Session 1
        jeeMainsS1Roll: "",
        jeeMainsS1: "",
        jeeMainsS1Physics: "",
        jeeMainsS1Chemistry: "",
        jeeMainsS1Math: "",

        // JEE Mains Session 2
        jeeMainsS2Roll: "",
        jeeMainsS2: "",
        jeeMainsS2Physics: "",
        jeeMainsS2Chemistry: "",
        jeeMainsS2Math: "",

        // JEE Advanced
        jeeAdvancedEligible: "",
        jeeAllIndiaRank: "",

        // Application Status
        applicationSubmitted: false,

        // Attachments
        attachments: []
    });

    const [errorMessage, setErrorMessage] = useState('');
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [showSubmitModal, setShowSubmitModal] = useState(false);
    const [file, setFile] = useState(null);
    const isValidFileType = (file) => {
        const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
        return allowedTypes.includes(file.type);
    };

    const handleSave = async () => {
        let mobile = localStorage.getItem('currentuser');
        let aadhar = localStorage.getItem('aadhar');

        if (!mobile || !aadhar) {
            alert("Please login first");
            window.location.href = '/';
            return;
        }
        if (fields.mobile == fields.whatsappMobile) {
            alert("Alternate mobile number must be different from the primary mobile number.");
            return;
        }

        console.log('FIELDS (Save): ', fields);

        try {
            let res = await callApis(`api/request/user/${mobile}/${aadhar}`, fields, 'PUT');

            if (res.message === "User updated successfully") {
                setShowSaveModal(true); // Show modal after saving
            }
        } catch (error) {
            console.error('Save error:', error);
            alert("Saving failed. Please try again.");
        }
    };


    const handleSiblingChange = (index, key, event) => {
        const value = event.target.value;

        setFields((prevFields) => {
            const updatedSiblings = Array.isArray(prevFields.siblings)
                ? [...prevFields.siblings]
                : [];
            updatedSiblings[index] = {
                ...updatedSiblings[index],  // Keep existing sibling data
                [key]: value
            };
            return {
                ...prevFields,
                siblings: updatedSiblings
            };
        });
    };

    const handleDownload = async (type) => {
        let mobile = localStorage.getItem('currentuser')
        let aadhar = localStorage.getItem('aadhar')
        // Fetch the image URL from the server
        const response = await fetch(`${_url}api/request/file/${mobile}/${aadhar}/${type}`)
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `DOC${Math.floor(Math.random() * 100000000 + 1)}`
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    };

    async function deleteDoc(val) {
        let mobile = localStorage.getItem('currentuser')
        let aadhar = localStorage.getItem('aadhar')
        const params = {
            files: val.files.map((item) => item.file),
            attachment_id: val._id,
            mobile: mobile,
            aadhar: aadhar,
        };

        let res = await callFetchApis(`api/request/${mobile}/${aadhar}`, params, 'DELETE')
        if (val && val.type === 'Applicant_Photo') {
            setApplicantPhotoUploaded(false)
        }
        console.log('Response: ', res);
        if (res.data && res.data.attachments.length) {
            setFields({ ...fields, attachments: res.data.attachments })
        } else {
            setFields({ ...fields, attachments: [] })
        }
    }

    async function updateStudent(dropped_file, fileType) {
        let mobile = localStorage.getItem('currentuser')
        let aadhar = localStorage.getItem('aadhar')
        if (dropped_file) {
            const formData = new FormData();
            formData.append('file', dropped_file)
            formData.append('type', fileType);
            await axios
                .post(`${_url}api/request/update/${mobile}/${aadhar}`, formData)
                .then((res) => {
                    if (res.data && res.data.data && res.data.data.attachments.length) {
                        setFields({ ...fields, attachments: res.data.data.attachments })
                    }
                });

        }
    }

    async function onDrop(dropped_file, fileType) {
        setFile('')
        setErrorMessage('')
        const file = dropped_file;
        const maxSizeMB = 10;

        if (file && file.size > maxSizeMB * 1024 * 1024) { // Convert MB to bytes
            alert('File size exceeds the maximum limit of ' + maxSizeMB + 'MB');
            file.value = ''; // Clear the file input
            // Reset file input
            return;
        }
        else if (!isValidFileType(dropped_file)) {
            alert('Selected file type of ' + dropped_file.type + ' is not allowed.');
            // Reset file input
            return;
        } else {
            if (fileType === 'Applicant_Photo') setApplicantPhotoUploaded(true)
            setFile(dropped_file.name);
            await updateStudent(dropped_file, fileType)
        }
    }

    const handleChange = (id, event) => {
        let value = event.target.value;
        setFields(prevFields => ({
            ...prevFields,
            [id]: value
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        let mobile = localStorage.getItem('currentuser');
        let aadhar = localStorage.getItem('aadhar');

        if (!mobile || !aadhar) {
            alert("Please login first");
            navigate('/')
            return;
        }

        if (!applicantPhotoUploaded) {
            alert("Please upload the Applicant's Photo");
            return;
        }
        console.log("mobile", fields.mobile);
        console.log("whatsappMobile", fields.whatsappMobile);
        if (fields.mobile == fields.whatsappMobile) {
            alert("Alternate mobile number must be different from the primary mobile number.");
            return;
        }

        try {
            const updatedFields = { ...fields, applicationSubmitted: "true" };

            let res = await callApis(`api/request/user/${mobile}/${aadhar}`, updatedFields, 'PUT');

            if (res.message === "User updated successfully") {
                setFields(updatedFields);
                setShowSubmitModal(true);
            }
        } catch (error) {
            console.error('Submission error:', error);
            alert("Submission failed. Please try again.");
        }
    };

    const getData = async () => {
        let mobile = localStorage.getItem('currentuser')
        let aadhar = localStorage.getItem('aadhar')

        // if (mobile === null || mobile === '' || aadhar === null || aadhar === '') window.location.href = 'https://admissions.sitare.org/'
        if (mobile === null || mobile === '' || aadhar === null || aadhar === '') window.location.href = '/'
        let res = await callGetApis(`api/request/user/${mobile}/${aadhar}`, {}, 'GET')
        if (res.message === "User fetched successfully") {
            const page = resolveAdminStatusPage(res._user.adminStatus);

            const flattenedFields = flattenMongoSchema(res._user);
            if (!flattenedFields.mobile) {
                flattenedFields.mobile = mobile
            }
            setFields(flattenedFields)
            const attachments = res._user?.attachments || [];
            const isApplicantPhotoUploaded = attachments.some(attachment => attachment.type === "Applicant_Photo" && attachment.files.length > 0);
            setApplicantPhotoUploaded(isApplicantPhotoUploaded)

            if (page === 'itr-upload') {
                setIsAccepted(true);
                return;
            }

            if (page === 'signed-letter-upload') {
                setIsSignedLetterRequired(true);
                return;
            }

            if (page === 'processing') {
                sessionStorage.setItem("inReview", true);
                sessionStorage.setItem("applicationProcessing", true);
                sessionStorage.setItem("applicationName", res._user.personalDetails?.firstName || 'Applicant');
                localStorage.removeItem('currentuser');
                localStorage.removeItem('aadhar');
                navigate('/in-review');
                return;
            }

            if (page === 'admission-decision') {
                sessionStorage.setItem("admissionDecision", true);
                sessionStorage.setItem("applicationName", res._user.personalDetails?.firstName || 'Applicant');
                localStorage.removeItem('currentuser');
                localStorage.removeItem('aadhar');
                navigate('/admission-decision');
                return;
            }

            if (page === 'withdrawn') {
                sessionStorage.setItem("withdrawn", true);
                sessionStorage.setItem("applicationName", res._user.personalDetails?.firstName || 'Applicant');
                localStorage.removeItem('currentuser');
                localStorage.removeItem('aadhar');
                navigate('/withdrawn');
                return;
            }
        }
    }
    useEffect(() => {
        getData()
    }, [])

    if (isSignedLetterRequired) {
        const allSignedLetterUploaded = signedLetterAttachmentsList.every(option =>
            fields.attachments && fields.attachments.some(
                attachment => attachment.type === option.value && attachment.files && attachment.files.length > 0
            )
        );
        return (
            <>
                <Navbar />
                <div className="user-container" style={{ flexDirection: 'column', textAlign: 'center', padding: '40px clamp(20px, 6vw, 60px)', boxSizing: 'border-box' }}>
                    <div style={{ maxWidth: '800px', width: '100%' }}>
                        <h3 style={{ color: '#007BFF' }}>
                            Please upload the signed copy of your admissions letter
                        </h3>
                    </div>
                    <div style={{ maxWidth: '800px', width: '80%' }}>
                        <FormSection title={<>Upload Document <span style={{ color: 'red', textDecoration: 'underline' }}>(Make sure the document is NOT password protected)</span></>} />
                    </div>
                    <div className="uploads-container" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div className="uploads-table-wrapper" style={{ maxWidth: '800px', width: '100%' }}>
                            <table className="uploads-table">
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: 'center' }}>Type</th>
                                        <th style={{ textAlign: 'center' }}>Choose File</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {signedLetterAttachmentsList.map((option, index) => (
                                        <tr key={option.value} className="uploads-table-row">
                                            <td className="uploads-type" style={{ textAlign: 'center' }}>
                                                <label className="label-with-tooltip" style={{ justifyContent: 'center' }}>
                                                    <span>
                                                        {option.display}{option.required && <span style={{ color: "red" }}>*</span>}
                                                        {option.subDisplay && option.subDisplay.trim() !== "" && (
                                                            <div style={{ fontSize: "0.8em", color: "#666", marginTop: "4px" }}>
                                                                {option.subDisplay}
                                                            </div>
                                                        )}
                                                    </span>
                                                </label>
                                            </td>
                                            <td className="uploads-file-input" style={{ textAlign: 'center' }}>
                                                {fields.attachments &&
                                                    fields.attachments.every(
                                                        (attachment) => attachment.type !== option.value
                                                    ) ? (
                                                    <div className="file-upload-container" style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <input
                                                            type="file"
                                                            accept={option.acceptType}
                                                            onChange={(e) => onDrop(e.target.files[0], option.value)}
                                                            className="file-input"
                                                        />
                                                    </div>
                                                ) :
                                                    <div className='uploads-button-container' style={{ display: "flex", alignItems: 'center', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                                        <p>✅ Uploaded</p>
                                                        <div style={{ alignItems: 'center' }}>
                                                            {fields.attachments &&
                                                                fields.attachments.map((attachment) => {
                                                                    if (attachment.type === option.value) {
                                                                        return (
                                                                            <div key={attachment.type + index} className="uploads-buttons">
                                                                                <button
                                                                                    type="button"
                                                                                    className="uploads-button download"
                                                                                    onClick={() => handleDownload(option.value)}
                                                                                >
                                                                                    Download
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className="uploads-button update"
                                                                                    onClick={() => deleteDoc(attachment)}
                                                                                >
                                                                                    Replace
                                                                                </button>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    return null;
                                                                })}
                                                        </div>
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {allSignedLetterUploaded && (
                        <div style={{ maxWidth: '800px', width: '100%', margin: '20px 0', padding: '15px', backgroundColor: '#e6f4ea', border: '1px solid #34a853', borderRadius: '8px' }}>
                            <p style={{ color: '#1e7e34', margin: 0, fontWeight: 'bold' }}>
                                Your signed admissions letter has been uploaded. We will reach out soon. Thank you!
                            </p>
                        </div>
                    )}
                    <div style={{ maxWidth: '800px', width: '100%' }}>
                        <p>
                            <strong>Need Assistance?</strong> Feel free to reach out to your case manager, email us at&nbsp;
                            <a href="mailto:university@sitare.org" style={{ textDecoration: 'none', color: '#007BFF' }}>
                                university@sitare.org
                            </a>
                            &nbsp;or message us on&nbsp;
                            <a href="https://wa.me/+917849910085" style={{ textDecoration: 'none', color: '#128c7e' }}>
                                WhatsApp (+91 78499 10085)
                            </a>.
                        </p>
                    </div>
                </div>
            </>
        );
    }

    if (isAccepted) {
        const allItrUploaded = itrAttachmentsList.every(option =>
            fields.attachments && fields.attachments.some(
                attachment => attachment.type === option.value && attachment.files && attachment.files.length > 0
            )
        );
        return (
            <>
                <Navbar />
                <div className="user-container" style={{ flexDirection: 'column', textAlign: 'center', padding: '40px clamp(20px, 6vw, 60px)', boxSizing: 'border-box' }}>
                    <div style={{ maxWidth: '800px', width: '100%' }}>
                        <h3 style={{ color: '#007BFF' }}>
                            Your application just needs a few more things!
                        </h3>
                        <p>
                            Please upload the following documents.

                        </p>
                    </div>
                    <div style={{ maxWidth: '800px', width: '80%' }}>
                        <FormSection title={<>Upload Documents <span style={{ color: 'red', textDecoration: 'underline' }}>(Make sure the document is NOT password protected)</span></>} />
                    </div>
                    <div className="uploads-container" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div className="uploads-table-wrapper" style={{ maxWidth: '800px', width: '100%' }}>
                            <table className="uploads-table">
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: 'center' }}>Type</th>
                                        <th style={{ textAlign: 'center' }}>Choose File</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itrAttachmentsList.map((option, index) => (
                                        <tr key={option.value} className="uploads-table-row">
                                            <td className="uploads-type" style={{ textAlign: 'center' }}>
                                                <label className="label-with-tooltip" style={{ justifyContent: 'center' }}>
                                                    <span>
                                                        {option.display}{option.required && <span style={{ color: "red" }}>*</span>}
                                                        {option.subDisplay && option.subDisplay.trim() !== "" && (
                                                            <div style={{ fontSize: "0.8em", color: "#666", marginTop: "4px" }}>
                                                                {option.subDisplay}
                                                            </div>
                                                        )}
                                                    </span>
                                                </label>
                                            </td>
                                            <td className="uploads-file-input" style={{ textAlign: 'center' }}>
                                                {fields.attachments &&
                                                    fields.attachments.every(
                                                        (attachment) => attachment.type !== option.value
                                                    ) ? (
                                                    <div className="file-upload-container" style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <input
                                                            type="file"
                                                            accept={option.acceptType}
                                                            onChange={(e) => onDrop(e.target.files[0], option.value)}
                                                            className="file-input"
                                                        />
                                                    </div>
                                                ) :
                                                    <div className='uploads-button-container' style={{ display: "flex", alignItems: 'center', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                                        <p>✅ Uploaded</p>
                                                        <div style={{ alignItems: 'center' }}>
                                                            {fields.attachments &&
                                                                fields.attachments.map((attachment) => {
                                                                    if (attachment.type === option.value) {
                                                                        return (
                                                                            <div key={attachment.type + index} className="uploads-buttons">
                                                                                <button
                                                                                    type="button"
                                                                                    className="uploads-button download"
                                                                                    onClick={() => handleDownload(option.value)}
                                                                                >
                                                                                    Download
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className="uploads-button update"
                                                                                    onClick={() => deleteDoc(attachment)}
                                                                                >
                                                                                    Replace
                                                                                </button>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    return null;
                                                                })}
                                                        </div>
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {allItrUploaded && (
                        <div style={{ maxWidth: '800px', width: '100%', margin: '20px 0', padding: '15px', backgroundColor: '#e6f4ea', border: '1px solid #34a853', borderRadius: '8px' }}>
                            <p style={{ color: '#1e7e34', margin: 0, fontWeight: 'bold' }}>
                                Your documents are uploaded. We will reach out soon. Thank you!
                            </p>
                        </div>
                    )}
                    <div style={{ maxWidth: '800px', width: '100%' }}>
                        <p>
                            <strong>Need Assistance?</strong> Feel free to reach out to your case manager, email us at&nbsp;
                            <a href="mailto:university@sitare.org" style={{ textDecoration: 'none', color: '#007BFF' }}>
                                university@sitare.org
                            </a>
                            &nbsp;or message us on&nbsp;
                            <a href="https://wa.me/+917849910085" style={{ textDecoration: 'none', color: '#128c7e' }}>
                                WhatsApp (+91 78499 10085)
                            </a>.
                        </p>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="user-container">
                <form onSubmit={handleSubmit} className="user-form">
                    <div>
                        {fields?.applicationSubmitted && (
                            <h3 style={{ textDecoration: 'none', color: '#007BFF' }}>Your application has been submitted. You can edit it until we start processing your application.</h3>
                        )}

                        <p>
                            <strong>Need Assistance?</strong> Feel free to reach out to us at&nbsp;
                            <a href="mailto:university@sitare.org" style={{ textDecoration: 'none', color: '#007BFF' }}>
                                university@sitare.org
                            </a>
                            &nbsp;or message us on&nbsp;
                            <a href="https://wa.me/+917849910085" style={{ textDecoration: 'none', color: '#128c7e' }}>
                                WhatsApp (+91 78499 10085)
                            </a>. 
                        </p>
                        <p>
                            <em>* Required fields are marked with an asterisk. We encourage you to complete as many fields as possible to help us assist you better.</em>
                        </p>
                    </div>

                    <FormSection title="Candidate Details" />
                    <div className="row">
                        <div className="column">
                            <label>First Name*</label>
                            <input type="text" required value={fields?.firstName} onChange={(e) => handleChange('firstName', e)} className="input-field-user" pattern="[A-Za-z\s\-]+" title="Only alphabets are allowed" />
                        </div>
                        <div className="column">
                            <label>Middle Name</label>
                            <input type="text" value={fields?.middleName} onChange={(e) => handleChange('middleName', e)} className="input-field-user" pattern="[A-Za-z\s\-]+" title="Only alphabets are allowed" />
                        </div>
                        <div className="column">
                            <label>Last  Name*</label>
                            <input type="text" required value={fields?.lastName} onChange={(e) => (handleChange('lastName', e))} className="input-field-user" pattern="[A-Za-z\s\-]+" title="Only alphabets are allowed" />
                        </div>
                        <div className="column">
                            <label>Date of Birth*</label>
                            <input type="date" required value={moment(fields?.dob).format("yyyy-MM-DD")} onChange={(e) => (handleChange('dob', e))} className="input-field-user" />
                        </div>
                        <div className="column">
                            <label>Gender*</label>
                            <select className="input-field-user" required value={fields?.gender} onChange={(e) => (handleChange('gender', e))}>
                                <option key={'Male'} value={'Male'}>Male</option>
                                <option key={'Female'} value={'Female'}>Female</option>
                            </select>
                        </div>
                        <div className="column">
                            <label>Category*</label>
                            <select className="input-field-user" required value={fields?.category} onChange={(e) => (handleChange('category', e))}>
                                <option key={'catGeneral'} value={'catGeneral'}>General</option>
                                <option key={'catEws'} value={'catEws'}>General-EWS</option>
                                <option key={'catObc'} value={'catObc'}>OBC</option>
                                <option key={'catNcl'} value={'catNcl'}>OBC-NCL</option>
                                <option key={'catSc'} value={'catSc'}>SC</option>
                                <option key={'catSt'} value={'catSt'}>ST</option>
                                <option key={'catOther'} value={'catGeneral'}>Other</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <label className="label-with-tooltip">
                                <span>Total Family Income* (Annual)</span>
                                <span className="tooltip">
                                    {<img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        Must be yearly income (वार्षिक आय)
                                    </span>
                                </span>
                            </label>
                            <input
                                type="tel"
                                required
                                value={fields?.familyIncome}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,12}$/.test(value)) {
                                        handleChange('familyIncome', e);
                                    }
                                }}
                                className="input-field-user"
                                placeholder="Income must be real"
                            />
                        </div>
                    </div>
                    <FormSection title="Contact Details" />
                    <div className="row">
                        <div className="column">
                            <label>Email*</label>
                            <input type="email" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}" title="Enter a valid email-id" required value={fields?.email} onChange={(e) => (handleChange('email', e))} className="input-field-user" />
                        </div>
                        <div className="column">
                            <label className="label-with-tooltip">
                                <span>Mobile Number*</span>
                                <span className="tooltip">
                                    {InfoIcon && <img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        It is fetched from your login information. If it is incorrect, please login with your correct mobile number. 
                                        Please provide a mobile number that is active on WhatsApp, as most communication will be shared via WhatsApp.
                                    </span>
                                </span>
                            </label>
                            <input
                                type="tel"
                                maxLength={10}
                                pattern="^[5-9][0-9]{9}$"
                                readOnly
                                value={fields?.mobile}
                                onChange={(e) => handleChange('mobile', e)}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <div>
                                <label className="label-with-tooltip" >
                                    <span>Alternate Mobile Number (Whatsapp)*</span>
                                    <span className="tooltip">
                                        {InfoIcon && <img src={InfoIcon} alt="Info" className="info-icon" />}
                                        <span className="tooltip-text">
                                            Please provide an alternate mobile number that is different from your primary mobile number. 
                                            A WhatsApp-enabled number is preferred as most communication will be shared via WhatsApp.
                                        </span>
                                    </span>
                                    {/* <input
                                        maxLength={10}
                                        type="checkbox"
                                        checked={fields.sameAsMobile || false}
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            handleChange('sameAsMobile', { target: { value: isChecked } });
                                            if (isChecked) {
                                                handleChange('whatsappMobile', {
                                                    target: { value: fields.mobile },
                                                });
                                            }
                                        }}
                                    />
                                    Same as mobile number */}
                                </label>
                            </div>
                            <input
                                maxLength={10}
                                type="tel"
                                pattern="^[5-9][0-9]{9}$"
                                required
                                value={fields?.whatsappMobile}
                                // onChange={(e) => handleChange('whatsappMobile', e)}
                                onChange={(e) => {
                                    if (e.target.value == fields.mobile) {
                                        alert("Alternate mobile number must be different from the primary mobile number.");
                                        return;
                                    }
                                    handleChange('whatsappMobile', e);
                                }}
                                className="input-field-user"
                                // disabled={fields.sameAsMobile}
                            />
                        </div>

                    </div>
                    <div className="row">
                        <div className="column">
                            <label className="label-with-tooltip">
                                <span>Current Address*</span>
                                <span className="tooltip">
                                    {InfoIcon && <img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        Enter your current address where you live.
                                    </span>
                                </span>
                            </label>
                            <input
                                type="text"
                                required
                                value={fields?.currentAddress}
                                onChange={(e) => {
                                    handleChange('currentAddress', e);
                                    if (fields.sameAsCurrent) {
                                        handleChange('permanentAddress', { target: { value: e.target.value } });
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div>
                                <label style={{ margin: 0 }}>Permanent Address*</label>
                                <label style={{ display: 'flex', alignItems: 'center', fontWeight: 'normal' }}>
                                    <input
                                        type="checkbox"
                                        checked={fields.sameAsCurrent || false}
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            handleChange('sameAsCurrent', { target: { value: isChecked } });

                                            if (isChecked) {
                                                handleChange('permanentAddress', {
                                                    target: { value: fields.currentAddress },
                                                });
                                            }
                                        }}
                                    />
                                    Same as current address
                                </label>
                            </div>
                            <input
                                type="text"
                                required
                                value={fields?.permanentAddress}
                                onChange={(e) => handleChange('permanentAddress', e)}
                                className="input-field-user"
                                disabled={fields.sameAsCurrent}
                            />
                        </div>
                    </div>

                    {/* <FormSection title="Family Details" />
                    <h3>Father's Details</h3>
                    <div className="row">
                        <div className="column">
                            <label>Father's Name*</label>
                            <input type="text" pattern="[A-Za-z\s\-]+" title="Only alphabets are allowed" required value={fields?.fatherName} onChange={(e) => handleChange('fatherName', e)} className="input-field-user" />
                        </div>
                        <div className="column">
                            <label>Father's Aadhar Number</label>
                            <input
                                type="text"
                                value={fields?.fatherAadhar}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Allow only digits and 12 characters
                                    if (/^\d{0,12}$/.test(value)) {
                                        handleChange('fatherAadhar', e);
                                    }
                                }}
                                className="input-field-user"
                                placeholder="Enter 12-digit valid Aadhar number"
                            />
                        </div>
                        <div className="column">
                            <label>Father's Mobile Number</label>
                            <input
                                maxLength={10}
                                type="tel"
                                pattern="^[5-9][0-9]{9}$"
                                required
                                value={fields?.fatherMobile}
                                onChange={(e) => handleChange('fatherMobile', e)}
                                className="input-field-user"
                                placeholder="Enter 10-digit valid mobile number"
                            />
                        </div>
                        <div className="column">
                            <label>Father's Occupation*</label>
                            <input type="text" pattern="[A-Za-z\s\-]+" title="Only alphabets are allowed" required value={fields?.fatherOccupation} onChange={(e) => (handleChange('fatherOccupation', e))} className="input-field-user" />
                        </div>
                        <div className="column">
                            <label className="label-with-tooltip">
                                <span>Father's Annual Income*</span>
                                <span className="tooltip">
                                    {<img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        Must be yearly income (वार्षिक आय)
                                    </span>
                                </span>
                            </label>
                            <input
                                type="text"
                                value={fields?.fatherIncome}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,12}$/.test(value)) {
                                        handleChange('fatherIncome', e);
                                    }
                                }}
                                className="input-field-user"
                                placeholder="Income must be real"
                            />
                        </div>
                    </div>
                    <h3>Mother's Details</h3>
                    <div className="row">
                        <div className="column">
                            <label>Mother's Name*</label>
                            <input type="text" pattern="[A-Za-z\s\-]+" title="Only alphabets are allowed" required value={fields?.motherName} onChange={(e) => handleChange('motherName', e)} className="input-field-user" />
                        </div>
                        <div className="column">
                            <label>Mother's Aadhar Number</label>
                            <input
                                type="text"
                                value={fields?.motherAadhar}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Allow only digits and 12 characters
                                    if (/^\d{0,12}$/.test(value)) {
                                        handleChange('motherAadhar', e);
                                    }
                                }}
                                className="input-field-user"
                                placeholder="Enter 12-digit valid Aadhar number"
                            />
                        </div>
                        <div className="column">
                            <label>Mother's Mobile Number</label>
                            <input
                                maxLength={10}
                                type="tel"
                                pattern="^[5-9][0-9]{9}$"
                                required
                                value={fields?.motherMobile}
                                onChange={(e) => handleChange('motherMobile', e)}
                                className="input-field-user"
                                placeholder="Enter 10-digit valid mobile number"
                            />
                        </div>
                        <div className="column">
                            <label>Mother's Occupation*</label>
                            <input type="text" pattern="[A-Za-z\s\-]+" title="Only alphabets are allowed" required value={fields?.motherOccupation} onChange={(e) => (handleChange('motherOccupation', e))} className="input-field-user" />
                        </div>
                        <div className="column">
                            <label className="label-with-tooltip">
                                <span>Mother's Annual Income*</span>
                                <span className="tooltip">
                                    {<img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        Must be yearly income (वार्षिक आय)
                                    </span>
                                </span>
                            </label>
                            <input
                                type="text"
                                value={fields?.motherIncome}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,12}$/.test(value)) {
                                        handleChange('motherIncome', e);
                                    }
                                }}
                                className="input-field-user"
                                placeholder="Income must be real"
                            />
                        </div>
                    </div>
                    <h3>Sibling Details</h3>
                    <div className="row">
                        <div className="column">
                            <label className="label-with-tooltip">
                                <span>Number of Siblings*</span>
                                <span className="tooltip">
                                    {InfoIcon && <img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        Enter number of total brothers and sisters you have.
                                    </span>
                                </span>
                            </label>
                            <input type="number" min="0" value={fields?.numSiblings} onChange={(e) => handleChange('numSiblings', e)} className="input-field-user" />
                        </div>
                    </div>
                    {Array.from({ length: fields.numSiblings || 0 }).map((_, index) => (
                        <div key={index} className='gray-container'>
                            <h3>Sibling {index + 1}</h3>
                            <div className="row">
                                <div className="column">
                                    <label>Brother/Sister*</label>
                                    <select
                                        required
                                        value={fields.siblings?.[index]?.siblingType || ""}
                                        onChange={(e) => handleSiblingChange(index, 'siblingType', e)}
                                        className="input-field-user"
                                    >
                                        <option value="">Select</option>
                                        <option value="Brother">Brother</option>
                                        <option value="Sister">Sister</option>
                                    </select>
                                </div>
                                <div className="column">
                                    <label>Name*</label>
                                    <input type="text" pattern="[A-Za-z\s\-]+" title="Only alphabets are allowed" required value={fields.siblings?.[index]?.name || ""} onChange={(e) => handleSiblingChange(index, 'name', e)} className="input-field-user" />
                                </div>
                                <div className="column">
                                    <label>Age*</label>
                                    <input
                                        type="number"
                                        min="0"
                                        max="99"
                                        required
                                        value={fields.siblings?.[index]?.age || ""}
                                        onChange={(e) => handleSiblingChange(index, 'age', e)}
                                        className="input-field-user"
                                    />
                                </div>

                                <div className="column">
                                    <label>Occupation</label>
                                    <select
                                        className="input-field-user"
                                        required
                                        value={
                                            ["Student", "Salaried", "Self Employeed", "Other"].includes(fields.siblings[index]?.occupation)
                                                ? fields.siblings[index]?.occupation
                                                : "Other"
                                        }
                                        onChange={(e) => {
                                            const selected = e.target.value;
                                            if (selected === "Other") {
                                                handleSiblingChange(index, "occupation", { target: { value: "" } });
                                            } else {
                                                handleSiblingChange(index, "occupation", e);
                                            }
                                        }}
                                    >
                                        <option value="">Select</option>
                                        <option value="Student">Student</option>
                                        <option value="Salaried">Salaried</option>
                                        <option value="Self Employeed">Self Employeed</option>
                                        <option value="Other">Other (Please Specify)</option>
                                    </select>
                                </div>

                                {!["Student", "Salaried", "Self Employeed"].includes(fields.siblings[index]?.occupation) && (
                                    <div className="column">
                                        <label>Please Specify</label>
                                        <input
                                            type="text"
                                            pattern="[A-Za-z\\s\\-]+"
                                            title="Only alphabets are allowed"
                                            value={fields.siblings[index]?.occupation}
                                            onChange={(e) => handleSiblingChange(index, "occupation", e)}
                                            className="input-field-user"
                                            required
                                        />
                                    </div>
                                )}
                                <div className="column">
                                    <label className="label-with-tooltip">
                                        <span>Annual Income*</span>
                                        <span className="tooltip">
                                            {<img src={InfoIcon} alt="Info" className="info-icon" />}
                                            <span className="tooltip-text">
                                                Must be yearly income (वार्षिक आय)
                                            </span>
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        value={fields.siblings?.[index]?.annualIncome || ""}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d{0,12}$/.test(value)) {
                                                handleSiblingChange(index, 'annualIncome', e);
                                            }
                                        }}
                                        className="input-field-user"
                                        placeholder="Income must be real"
                                    />
                                </div>
                            </div>
                        </div>
                    ))} */}
                    <FormSection title="Academics" />
                    <h2>10th Class</h2>
                    <div className="row">
                        <div className="column">
                            <label>10th Board* (e.g. CBSE Board, UP Board, etc.)</label>
                            <input type="text" title="Only alphabets are allowed" required value={fields?.board10} onChange={(e) => handleChange('board10', e)} className="input-field-user" />
                            {/* pattern="[A-Za-z\s\-]+" */}
                        </div>
                        <div className="column">
                            <label>Grade X Math Percentage*</label>
                            <input type="text" required maxLength={7} value={fields?.math10}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('math10', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label>Grade X Science Percentage*</label>
                            <input type="text" required maxLength={7} value={fields?.science10}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('science10', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label>Grade X English Percentage*</label>
                            <input type="text" required maxLength={7} value={fields?.english10}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('english10', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label>School Name*</label>
                            <input type="text" title="Only alphabets are allowed" required value={fields?.school10} onChange={(e) => handleChange('school10', e)} className="input-field-user" />
                            {/* pattern="[A-Za-z\s\-]+"  */}
                        </div>
                        <div className="column">
                            <label>State*</label>
                            <input type="text" pattern="[A-Za-z\s\-]+" title="Only alphabets are allowed" required value={fields?.state10} onChange={(e) => handleChange('state10', e)} className="input-field-user" />
                        </div>
                        <div className="column">
                            <label>School Type*</label>
                            <select
                                value={fields?.schoolType10 || ""}
                                required
                                onChange={(e) => handleChange("schoolType10", e)}
                                className="input-field-user"
                            >
                                <option value="" disabled>Select school type</option>
                                <option value="Government">Government</option>
                                <option value="Private">Private</option>
                            </select>
                        </div>
                        <div className="column">
                            <label>10th Overall Percentage*</label>
                            <input type="text" required maxLength={7} value={fields?.overall10}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('overall10', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                    </div>
                    <h2>12th Class</h2>
                    <div className="row">
                        <div className="column">
                            <label>12th Board (e.g. CBSE Board, UP Board, etc.)</label>
                            <input type="text" value={fields?.board12} onChange={(e) => handleChange('board12', e)} className="input-field-user" />
                        </div>
                        <div className="column">
                            <label>Grade XII Math Percentage</label>
                            <input type="text" maxLength={7} value={fields?.math12}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('math12', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label>Grade XII Physics Percentage</label>
                            <input type="text" maxLength={7} value={fields?.science12}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;  // Up to 100, 3 decimal places allowed
                                    if (value === '' || regex.test(value)) {
                                        handleChange('physics12', e);  // Update the value in state
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label>Grade XII English Percentage</label>
                            <input type="text" maxLength={7} value={fields?.english12}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('english12', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label>School Name*</label>
                            <input type="text" title="Only alphabets are allowed" required value={fields?.school12} onChange={(e) => handleChange('school12', e)} className="input-field-user" />
                            {/* pattern="[A-Za-z\s\-]+"  */}
                        </div>
                        <div className="column">
                            <label>State</label>
                            <input type="text" pattern="[A-Za-z\s\-]+" title="Only alphabets are allowed" value={fields?.state12} onChange={(e) => handleChange('state12', e)} className="input-field-user" />
                        </div>
                        <div className="column">
                            <label>School Type*</label>
                            <select
                                value={fields?.schoolType12 || ""}
                                required
                                onChange={(e) => handleChange("schoolType12", e)}
                                className="input-field-user"
                            >
                                <option value="" disabled>Select school type</option>
                                <option value="Government">Government</option>
                                <option value="Private">Private</option>
                            </select>
                        </div>
                        <div className="column">
                            <label>12th Overall Percentage</label>
                            <input type="text" maxLength={7} value={fields?.overall12}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('overall12', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                    </div>
                    <h2>JEE Mains Session One</h2>
                    <div className="row">
                        <div className="column">

                            <label>Roll Number (JEE Mains Session One)*</label>
                            <input type="text" required maxLength={15} value={fields?.jeeMainsS1Roll} onChange={(e) => (handleChange('jeeMainsS1Roll', e))} className="input-field-user" />                        </div>
                        <div className="column">
                            <label>JEE Mains Session One Total NTA Score (in percentile)*</label>
                            <input type="text" required maxLength={7} value={fields?.jeeMainsS1}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('jeeMainsS1', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label>JEE Mains Session One Physics  (in percentile)*</label>
                            <input type="text" required maxLength={7} value={fields?.jeeMainsS1Physics}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('jeeMainsS1Physics', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label>JEE Mains Session One Chemistry (in percentile)*</label>
                            <input type="text" required maxLength={7} value={fields?.jeeMainsS1Chemistry}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('jeeMainsS1Chemistry', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label>JEE Mains Session One Math (in percentile)*</label>
                            <input type="text" required maxLength={7} value={fields?.jeeMainsS1Math}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('jeeMainsS1Math', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                    </div>
                    <h2>JEE Mains Session Two</h2>
                    <div className="row">
                        <div className="column">
                            <label className="label-with-tooltip">
                                <span>Roll Number (JEE Mains Session Two)*</span>
                                <span className="tooltip">
                                    {<img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        Please fill 0 if not available
                                    </span>
                                </span>
                            </label>
                            <input type="text" required maxLength={15} value={fields?.jeeMainsS2Roll} onChange={(e) => (handleChange('jeeMainsS2Roll', e))} className="input-field-user" />
                        </div>

                        <div className="column">
                            <label className="label-with-tooltip">
                                <span>JEE Mains Session Two Total NTA Score (in percentile)*</span>
                                <span className="tooltip">
                                    {<img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        Please fill 0 if not available
                                    </span>
                                </span>
                            </label>
                            <input type="text" required maxLength={7} value={fields?.jeeMainsS2}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('jeeMainsS2', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label className='label-with-tooltip'>
                                <span>JEE Mains Session Two Physics (in percentile)*</span>
                                <span className="tooltip">
                                    {<img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        Please fill 0 if not available
                                    </span>
                                </span>
                            </label>
                            <input type="text" required maxLength={7} value={fields?.jeeMainsS2Physics}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('jeeMainsS2Physics', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label className="label-with-tooltip">
                                <spann>JEE Mains Session Two Chemistry (in percentile)*</spann>
                                <span className="tooltip">
                                    {<img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        Please fill 0 if not available
                                    </span>
                                </span>
                            </label>
                            <input type="tel" required maxLength={7} value={fields?.jeeMainsS2Chemistry}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('jeeMainsS2Chemistry', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                        <div className="column">
                            <label className="label-with-tooltip">
                                <span>JEE Mains Session Two Math (in percentile)*</span>
                                <span className="tooltip">
                                    {<img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        Please fill 0 if not available
                                    </span>
                                </span>
                            </label>
                            <input type="text" required maxLength={7} value={fields?.jeeMainsS2Math}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^(100(\.0{0,3})?|(\d{1,2})(\.\d{0,3})?)$/;
                                    if (value === '' || regex.test(value)) {
                                        handleChange('jeeMainsS2Math', e);
                                    }
                                }}
                                className="input-field-user"
                            />
                        </div>
                    </div>

                    <h2>JEE Advanced</h2>
                    <div className="row">
                        <div className="column">
                            <label className="label-with-tooltip">
                                <span>JEE Mains All India Rank (CRL)</span>
                                <span className="tooltip">
                                    {InfoIcon && <img src={InfoIcon} alt="Info" className="info-icon" />}
                                    <span className="tooltip-text">
                                        Enter your common rank (No category rank).
                                    </span>
                                </span>
                            </label>
                            <input type="tel" maxLength={6} value={fields?.jeeAllIndiaRank} onChange={(e) => (handleChange('jeeAllIndiaRank', e))} className="input-field-user"
                                onKeyDown={(e) => {
                                    if (
                                        !(e.keyCode >= 48 && e.key <= 57) && // Numeric keys
                                        e.keyCode !== 8 && // Backspace
                                        e.keyCode !== 46 && // Delete
                                        e.keyCOde !== 190 && // Period
                                        e.keyCode !== 9 && // Tab
                                        e.keyCode !== 37 && // Left arrow
                                        e.keyCode !== 39 // Right arrow
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </div>
                        <div className="column">
                            <label>Eligible for JEE Advanced</label>
                            <select
                                value={fields?.jeeAdvancedEligible || ""}
                                onChange={(e) => handleChange("jeeAdvancedEligible", e)}
                                className="input-field-user"
                            >
                                <option value="" disabled>Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                    </div>

                    <h2>Other</h2>
                    <div className="row">
                        <div className="column">
                            <label>Coaching By</label>
                            <select
                                className="input-field-user"
                                required
                                value={fields?.coachingBy}
                                onChange={(e) => handleChange('coachingBy', e)}
                            >
                                <option key={'Dakshana-Foundation'} value={'Dakshana Foundation'}>Dakshana Foundation</option>
                                <option key={'Physics-Wallah'} value={'Physics Wallah'}>Physics Wallah</option>
                                <option key={'Avanti-Fellows'} value={'Avanti Fellows'}>Avanti Fellows</option>
                                <option key={'Ex-Navodayan'} value={'Ex-Navodayan'}>Ex-Navodayan</option>
                                <option key={'CSRL'} value={'CSRL'}>CSRL</option>
                                <option key={'Top-Neurons'} value={'Top Neurons'}>Top Neurons</option>
                                <option key={'Others'} value={'Others'}>Others (Please Specify)</option>
                            </select>
                        </div>

                        {fields?.coachingBy === 'Others' && (
                            <div className="column">
                                <label>Please Specify (Say 'Self-Study' if no coaching)</label>
                                <input
                                    type="text" pattern="[A-Za-z\s\-]+" title="Only alphabets are allowed"
                                    value={fields?.coachingByOthers}
                                    onChange={(e) => handleChange('coachingByOthers', e)}
                                    className="input-field-user"
                                    required
                                />
                            </div>
                        )}
                    </div>

                    <FormSection title={<>Upload Documents <span style={{ color: 'red', textDecoration: 'underline' }}>(Make sure the document is NOT password protected)</span></>} />
                    <div className="uploads-container">
                        <div className="uploads-table-wrapper">
                            <table className="uploads-table">
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Choose File</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attachmentsList.map((option, index) => (
                                        <tr key={option.value} className="uploads-table-row">
                                            <td className="uploads-type">
                                                <label className="label-with-tooltip">
                                                    <span>
                                                        {option.display}{option.required && <span style={{ color: "red" }}>*</span>}
                                                        {option.subDisplay && option.subDisplay.trim() !== "" && (
                                                            <div style={{ fontSize: "0.8em", color: "#666", marginTop: "4px" }}>
                                                                {option.subDisplay}
                                                            </div>
                                                        )}
                                                    </span>
                                                </label>
                                            </td>
                                            <td className="uploads-file-input">
                                                {fields.attachments &&
                                                    fields.attachments.every(
                                                        (attachment) => attachment.type !== option.value
                                                    ) ? (
                                                    <div className="file-upload-container">
                                                        <input
                                                            type="file"
                                                            accept={option.acceptType}
                                                            onChange={(e) => onDrop(e.target.files[0], option.value)}
                                                            className="file-input"
                                                            required={option.required}
                                                        />
                                                    </div>
                                                ) :
                                                    <div className='uploads-button-container' style={{ display: "flex", alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                                        <p>✅ Uploaded</p>
                                                        <div style={{ alignItems: 'center' }}>
                                                            {fields.attachments &&
                                                                fields.attachments.map((attachment) => {
                                                                    if (attachment.type === option.value) {
                                                                        return (
                                                                            <div key={attachment.type + index} className="uploads-buttons">
                                                                                <button
                                                                                    type="button"
                                                                                    className="uploads-button download"
                                                                                    onClick={() => handleDownload(option.value)}
                                                                                >
                                                                                    Download
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className="uploads-button update"
                                                                                    onClick={() => deleteDoc(attachment)}
                                                                                >
                                                                                    Replace
                                                                                </button>
                                                                            </div>
                                                                        );
                                                                    }
                                                                    return null;
                                                                })}
                                                        </div>
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="error-div">
                        {/* Your JSX */}
                        {errorMessage && <p>{errorMessage}</p>}
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: "10px",
                            justifyContent: "flex-end",
                            paddingTop: "20px",
                        }}
                    >
                        {/* <a
                            href={require("./declaration.pdf")}
                            download="declaration.pdf"
                            className="declaration-button"
                            style={{ cursor: "pointer", textDecoration: "none" }}
                        >
                            Download Declaration Format
                        </a> */}
                        <button
                            type="button"
                            onClick={handleSave}
                            className="save-button responsive-button"
                            style={{ cursor: "pointer" }}
                        >
                            Save Application
                        </button>
                        <button
                            type="submit"
                            className="save-button responsive-button"
                            style={{ cursor: "pointer" }}
                        >
                            {fields.applicationSubmitted ? "Re-submit Application" : "Submit Application"}
                        </button>
                    </div>

                    {/* Save Confirmation Modal */}
                    {showSaveModal && (
                        <div style={{
                            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                            alignItems: 'center', justifyContent: 'center', zIndex: 1000
                        }}>
                            <div style={{
                                background: '#fff', padding: '25px', borderRadius: '8px', textAlign: 'center',
                                boxShadow: '0 4px 10px rgba(0,0,0,0.25)'
                            }}>
                                Your application has been saved, but it hasn't been submitted yet. <br />
                                You can come back later and modify it before the deadline.


                                <p>Kindly click <strong>Submit Application</strong> to complete your application process. </p>
                                <div style={{ marginTop: '1px' }}>
                                    <button onClick={() => setShowSaveModal(false)} className="uploads-button download" >
                                        Got it!
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Submit Confirmation Modal */}
                    {showSubmitModal && (
                        <div style={{
                            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                            alignItems: 'center', justifyContent: 'center', zIndex: 1000
                        }}>
                            <div style={{
                                background: '#fff', padding: '25px', borderRadius: '8px', textAlign: 'center',
                                boxShadow: '0 4px 10px rgba(0,0,0,0.25)'
                            }}>
                                Your application has been submitted. <br />
                                You can still come back and edit it until the deadline: {APPLICATION_EDIT_DEADLINE_DISPLAY}.
                                <div style={{ marginTop: '15px' }}>
                                    <button onClick={() => setShowSubmitModal(false)} className="uploads-button download" >
                                        Got it!
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                </form>
            </div>
        </>
    );
};

export default UserDetailsComponent;
